<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M9 3v1H4v2h1v13a2 2 0 002 2h10a2 2 0 002-2V6h1V4h-5V3H9m0 5h2v9H9V8m4 0h2v9h-2V8z"/>
    </svg>
</template>

<script>
export default {
    name: 'TrashCanIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
